export const langMixins = {
  methods: {
    langFn(p = '/', id) {
      if (this.$route?.query?.lang) {
        console.log('存在 :>> ')
        if (this.$route.query.lang === 'en') {
          this.$i18n.locale = 'en'
          // this.$refs.formPageRef.changeLanguage('zh')
          window.sessionStorage.setItem('sessionLang', 'en')
        } else {
          this.$i18n.locale = 'zh'
          let query_ = { lang: 'zh' }
          if (id) {
            query_.id = id;
          }
          this.$router
            .push({ path: p, query: query_ })
            .catch(() => { })
          window.sessionStorage.setItem('sessionLang', 'zh')
        }
      } else {
        let lang = window.sessionStorage.getItem('sessionLang') || 'zh'
        console.log('不存在 :>> -sessionStorage', lang)
        if (lang === 'zh') {
          console.log('进入11111', lang)
          let query_ = { lang: 'zh' }
          if (id) {
            query_.id = id;
          }
          this.$router
            .push({ path: p, query: query_ })
            .catch(() => { })
          this.$i18n.locale = 'zh'
        } else {
          console.log('进入22222', lang)
          let query_ = { lang: 'zh' }
          if (id) {
            query_.id = id;
          }
          this.$router
            .push({ path: p, query: query_ })
            .catch(() => { })
          this.$i18n.locale = 'en'
          // this.$refs.formPageRef.changeLanguage('zh')
        }
      }
    }
  }
}
